<template>
    <div class="container-form">
        <form class="reset-password-form">
            <legend>Recuperar contraseña</legend>
            <div>
                <label class="label-form">Ingrese nueva contraseña</label>
                <input class="input-form" v-model="newPassword" type="password"
                @input="Change_save_buttom(isMatchPassword, isValidPassword)"/>
                <p v-if="!isValidPassword">La contraseña debe tener al menos 8 caracteres, 1 número y 1 caracter especial.</p>
            </div>
            <div>
                <label class="label-form">Confirme su contraseña</label>
                <input class="input-form" v-model="confirmedPassword" type="password"
                @input="Change_save_buttom(isMatchPassword, isValidPassword)"/>
                <p v-if="!isMatchPassword">Las contraseñas no coinciden</p>
            </div>
            <button class="button-save"
            @click.prevent="SavePassword()"
            :disabled='!seeButton'
            :class="(seeButton) ? '' : 'button-send'">Guardar</button>
        </form>
    </div>
</template>

<script>
import router from '../../router';
import { mapActions, mapState } from 'vuex';
export default {
    name: 'PasswordReset',
    data(){
        return {
            newPassword: '',
            confirmedPassword: ''
        };
    },
    computed: {
        ...mapState(['seeButton']),
        isValidPassword() {
            const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
            return passwordRegex.test(this.newPassword);
        },
        isMatchPassword(){
            return this.newPassword === this.confirmedPassword
        }
    },
    methods: {
        ...mapActions(['passwordReset', 'Change_save_buttom']),
        async SavePassword(){
            try {
                await this.passwordReset(this.newPassword)
                router.push('/login')
            } catch (error) {
                router.push('/PasswordResetEmail')
                console.log(error)
            }
        }
    }
}
</script>
<style scoped>
.container-form {
    font-family: "Ancizar-regular", Helvetica, Arial;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1.5rem 0rem .5rem 0rem;
}
.reset-password-form {
    max-height: 100%;
    width: 28rem;
    box-sizing: border-box;
    border: 0.15rem solid rgb(100, 120, 20);
    border-radius: .5rem;
    margin-bottom: -1px;
}
.label-form {
    font-size: 1.1rem;
    padding-left: 2rem;
    padding-top: .5rem;
}
.input-form {
    margin: 0.5rem 0rem .5rem 2rem;
    height: 2.4rem;
    width: 19rem;
    border: 1px solid rgba(55, 55, 55, 0.7);
    border-radius: .5rem;
    padding: 1rem;
}
legend {
    background-color: rgb(100, 120, 20);
    color:white;
    font-size: 1.6rem;
    padding: .3rem 0rem .3rem 2rem;
}
.button-save {
    width: 8rem;
    color: white;
    height: 2.5em;
    background-color: rgb(100, 120, 20);
    border-radius: .3rem;
    font-size: 1.1rem;
    margin: .3rem 0rem .8rem 2rem;
}
p {
    padding: 0rem 3.5rem .3rem 2rem;
    font-size: .95rem;
    color: rgb(84, 104, 5);
    font-weight: bold;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.button-send{
    width: 8rem;
    color: white;
    height: 2.5em;
    margin: .3rem 0rem .8rem 2rem;
    border: none;
    background-color: rgba(100, 120, 20, 0.658);
}

@media (max-width: 769px) {
    .reset-password-form,
    .button-save,
    .input-form {
    max-width: 80% !important;
  }
 }
</style>